import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Policy } from "../../schema/types/policy/entity";

export const policyApi = createApi({
  reducerPath: "policyApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Policy"],
  endpoints: (builder) => ({
    getPolicy: builder.query<Policy, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Policy", id: link }],
    }),
  }),
});

export const { useGetPolicyQuery } = policyApi;
